import { render, staticRenderFns } from "./PartRoleMenus.vue?vue&type=template&id=20b5d37a"
import script from "./PartRoleMenus.vue?vue&type=script&setup=true&lang=js"
export * from "./PartRoleMenus.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b5d37a')) {
      api.createRecord('20b5d37a', component.options)
    } else {
      api.reload('20b5d37a', component.options)
    }
    module.hot.accept("./PartRoleMenus.vue?vue&type=template&id=20b5d37a", function () {
      api.rerender('20b5d37a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/role/components/PartRoleMenus.vue"
export default component.exports